import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { ROUTES } from 'config/routes'
import { deliveryReportStorage } from 'repositories/DeliveryReportStorage'
import { getDeliveryReportTenant } from 'repositories/ShipmentApi/getDeliveryReportTenant'
import { TruckbookApiResponseError } from 'repositories/TruckbookApiResponseError'

type Params = {
  deliveryReportUid: string
}

type PageState = 'loading' | 'ready' | 'invalid_uid' | 'network_error'

export const useSpDeliveryReportController = () => {
  const { deliveryReportUid } = useParams<Params>()
  const history = useHistory()
  const { search } = useLocation()
  const workUrl = `${ROUTES.spDeliveryReportWork.replace(':deliveryReportUid', deliveryReportUid)}${search}`

  const [pageState, setPageState] = useState<PageState>('loading')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const initialPhone = deliveryReportStorage.getDriverPhone()

  useEffect(() => {
    getDeliveryReportTenant(deliveryReportUid)
      .then(() => setPageState('ready'))
      .catch((error) => {
        if (error instanceof TruckbookApiResponseError && error.httpStatus === 404) {
          setPageState('invalid_uid')
        } else {
          setPageState('network_error')
        }
      })
  }, [deliveryReportUid])

  const handleSubmit = useCallback(
    (driverPhone: string) => {
      deliveryReportStorage.setDriverPhone(driverPhone)
      history.push(workUrl)
    },
    [history, workUrl]
  )

  const handleClose = useCallback(() => {
    history.goBack()
  }, [history])

  return {
    pageState,
    errorMessage,
    initialPhone,
    handleSubmit,
    handleClose,
  }
}
